import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
    SharedNavigationManagerRemoveLastRouteAction,
    SharedNavigationManagerResetAction,
    SharedNavigationManagerSetRouteAction
} from 'src/app/_shared/stores/shared-navigation-manager/shared-navigation-manager.actions';
import cloneDeep from 'lodash-es/cloneDeep';
import { LayoutNavigationExtra, LayoutRoute } from 'src/app/_core/services/layout.service';

export class SharedNavigationManagerStateModel<F = any> {
    routesList: [LayoutRoute, LayoutNavigationExtra][] = [];
}

@Injectable()
@State<SharedNavigationManagerStateModel>({
    name: 'navigationManagerState',
    defaults: new SharedNavigationManagerStateModel()
})
export class SharedNavigationManagerState {

    @Selector()
    static routesList(state: SharedNavigationManagerStateModel): [LayoutRoute, LayoutNavigationExtra][] {
        return state.routesList;
    }

    @Selector()
    static previousRoute(state: SharedNavigationManagerStateModel): [LayoutRoute, LayoutNavigationExtra] {
        return state.routesList[1] || null;
    }

    @Action(SharedNavigationManagerSetRouteAction)
    setRoute({patchState, getState}: StateContext<SharedNavigationManagerStateModel>, {route}: SharedNavigationManagerSetRouteAction) {
        const routesList = cloneDeep(getState().routesList);
        routesList.splice(0, 0, route);

        if (routesList.length > 5) {
            routesList.pop();
        }

        patchState({
            routesList
        });
    }

    @Action(SharedNavigationManagerRemoveLastRouteAction)
    removeLastRoute({patchState, getState}: StateContext<SharedNavigationManagerStateModel>) {
        const routesList = cloneDeep(getState().routesList);
        routesList.splice(0, 1);

        patchState({
            routesList
        });
    }

    @Action(SharedNavigationManagerResetAction)
    reset({patchState}: StateContext<SharedNavigationManagerStateModel>) {
        patchState(new SharedNavigationManagerStateModel());
    }

}
